export default __webpack_public_path__ + "static/media/faq-img.c41e976a.png";